module.exports = __webpack_public_path__ + "static/img/Rectangle-12.f164179.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/Rectangle-12.png
// module id = YsIe
// module chunks = 0